/*
 * @Author: 丨小小风离丨
 * @Date: 2023-12-04 19:54:32
 * @LastEditTime: 2024-01-03 18:54:24
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-enroll\src\router\index.tsx
 * @Description: 
 */

import { Suspense, lazy } from 'react';
import { routeTs } from '../types/types';
import LoadingSpinner from '@/components/loadingSpinner';
import pageRout from './pageRout';
const Home = lazy(() => import('@/page/index'))


const routes: routeTs[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingSpinner />}><Home /></Suspense>,
    children: [
      ...pageRout
    ]
  }
];

export default routes;
